import { Component, OnInit } from "@angular/core";
import { CompanypagesService } from "src/app/_services/companypages.service";
import { Router } from "@angular/router";
import {Title} from "@angular/platform-browser";

@Component({
  selector: "app-companydirectory",
  templateUrl: "./companydirectory.component.html",
  styleUrls: ["./companydirectory.component.scss"],
})
export class CompanydirectoryComponent implements OnInit {

  industryList = [];
  start = 0;
  end = 60;
  paginationOffset = 60;
  paginationArray = [];
  type = 'industry';
  totalIndustries = 0;
  activePage = 0;
  lastPageNumber;
  timeout;
  prevPage = 0;

  //search
  searchList = [];
  searchName = '';
  searchRedirectUrl = "";
  
  constructor(private _companypagesservice: CompanypagesService, private router: Router, private titleService:Title) {
  }

  ngOnInit(): void {
    this.getIndustryList(this.start,this.end);
    this.getSearchList(this.searchName);
  }

  getIndustryList(start,end){
    this._companypagesservice.getIndustryList(start, end, this.paginationOffset, this.type).subscribe((data:any) => {
      if(data && data.status == 'success'){
        this.industryList = data.finalData;
        this.paginationArray = data.pagesArray;
        this.lastPageNumber = this.paginationArray[this.paginationArray.length - 1];
        this.totalIndustries = data.totalIndustries;
      }
    })
  }

  onKeyPress(name){
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getSearchList(name);
    },200);
  }

  getSearchList(name){
    this._companypagesservice.companyDirectorySearch(name).subscribe((data:any) => {
      if(data.status == 'success'){
        data.finalData.forEach((item:any) => {
          item.name = this._companypagesservice.removeHyphen(item.name);
        })
        this.searchList = data.finalData;
      }
    })
  }

  pagination(type, pageNum=1){
    let callApi = true;
    switch (type) {
      case "next":
        this.start += this.paginationOffset;
        this.end += this.paginationOffset;
        if(this.activePage < (Math.ceil(this.totalIndustries/this.paginationOffset))-1){
          this.activePage++;
        } else {
          callApi = false;
        }
        if (this.end > this.totalIndustries) this.end = this.totalIndustries;
        break;

      case "prev":
        this.end = this.start;
        this.start -= this.paginationOffset;
        if (this.start < 0) {
          this.start = 0;
          this.end = this.paginationOffset;
        }
        if(this.activePage>=1){
          this.activePage--;
        } else {
          callApi = false;
        }
        break;
      
      case "page":
        if(pageNum != this.prevPage){
          this.prevPage = pageNum;
          this.activePage = pageNum;
          this.start = pageNum*this.paginationOffset;
          this.end = this.start + this.paginationOffset;
        } else {
          callApi = false;
        }
        break;
    }
    if(callApi){
      this.getIndustryList(this.start, this.end);
    }
  }

  searchRedirect(name,type, id){
    if(type == 'industry'){
      if(name){
        name = name.split(' ').join('-');
      } else{
        name = '';
      }
      this.searchRedirectUrl = `/company-directory/${name}-overview-${id}`;
      this.router.navigate([this.searchRedirectUrl]);
    } else if( type == 'company'){
      this.searchRedirectUrl = `/company-directory/${name}/${id}`;
      this.router.navigate([this.searchRedirectUrl]);
    }  
  }
}
